import { orchestrator } from "satcheljs";
import { setSelectedGroupId, setShiftBlocks, setShiftBlocksSnapshot } from "../mutatorActions/actions";
import { TeamStore } from "sh-team-store";
import { trace } from "owa-trace";
import setSmartScheduleSelectedGroup from "../actions/setSmartScheduleSelectedGroup";
import { TeamDataService } from "../../../../sh-services";

/**
 * Orchestrator: onSelectSmartScheduleGroup
 * Fetches shift blocks for the selected group/tag when a group is selected.
 */
export const onSelectSmartScheduleGroup = orchestrator(
    setSmartScheduleSelectedGroup,
    async actionMessage => {
        const { groupId } = actionMessage;
        if (!groupId) {
            // If no group selected, clear shift blocks
            setShiftBlocks([]);
            setShiftBlocksSnapshot([]);
            return;
        }

        const teamId = TeamStore()?.teamId;
        if (!teamId) {
            trace.warn("onSelectSmartScheduleGroup: No teamId available");
            setShiftBlocks([]);
            setShiftBlocksSnapshot([]);
            return;
        }

        setSelectedGroupId(groupId);

        try {
            // Fetch shift blocks for the selected tag/group
            const shiftBlocks = await TeamDataService.getShiftBlocksByTagId(teamId, groupId);

            // Update the store with the fetched shift blocks
            setShiftBlocks(shiftBlocks || []);
            // Take a snapshot for change detection
            setShiftBlocksSnapshot(shiftBlocks || []);
        } catch (error) {
            trace.error(`onSelectSmartScheduleGroup: Failed to fetch shift blocks for tagId ${groupId}: ${error}`);
            // On error, clear shift blocks to avoid showing stale data
            setShiftBlocks([]);
            setShiftBlocksSnapshot([]);
        }
    }
);

export default onSelectSmartScheduleGroup;
